import { createFileRoute, SearchSchemaInput } from "@tanstack/react-router";

import CompetitionOverview from "@/components/CompetitionOverview/CompetitionOverview";
import { CompetitionContextProvider } from "@/components/CompetitionOverview/CompetitionProvider";

const Component = () => {
  const search = Route.useSearch();
  return (
    <CompetitionContextProvider>
      <CompetitionOverview initialTab={search.tab} />
    </CompetitionContextProvider>
  );
};

export const Route = createFileRoute("/gym/$venueUuid/events/")({
  component: Component,
  validateSearch: (search: { tab?: string } & SearchSchemaInput) => {
    console.log("validate", search.tab);
    if (search.tab && !["profile", "routes", "competitors"].includes(search.tab as string)) {
      return { tab: "profile" } as const;
    }
    return {
      tab: search.tab as "profile" | "routes" | "competitors" | undefined,
    };
  },
});
